// Events
import { COUNTDOWN_UPDATE, REGISTER_COUNTDOWN } from 'events';
import { component } from 'picoapp';

export default component(async (node, ctx) => {
  const date = node.dataset.endDate;
  const daysContainer = node.querySelector('[data-days]');
  const hoursContainer = node.querySelector('[data-hours]');
  const minutesContainer = node.querySelector('[data-minutes]');
  const secondsContainer = node.querySelector('[data-seconds]');

  ctx.emit(REGISTER_COUNTDOWN, null, date);

  ctx.on(COUNTDOWN_UPDATE(date), (state, { days, hours, minutes, seconds }) => {
    daysContainer.textContent = days.toString().padStart(2, '0');
    hoursContainer.textContent = hours.toString().padStart(2, '0');
    minutesContainer.textContent = minutes.toString().padStart(2, '0');
    secondsContainer.textContent = seconds.toString().padStart(2, '0');
  });
});
